import { Component, OnInit, ViewChild } from "@angular/core";
import { AdmihairBaseComponent } from "../../../admihair-base.component";
import { ErroService } from "src/app/admihair/service/erro.service";
import { UtilStorageService } from "src/app/admihair/service/util-storage.service";
import { Cliente } from "src/app/admihair/api/dto/cliente";
import { ClienteService } from "src/app/admihair/service/cliente.service";
import { ActivatedRoute, Router } from "@angular/router";
import { ContatoCliente } from "src/app/admihair/api/dto/contato-cliente";
import { ContatoClienteService } from "src/app/admihair/service/contato-cliente.service";
import { ConfirmationService } from "primeng/api";
import { IndicadorClienteService } from "src/app/admihair/service/indicador-cliente.service";
import { IndicadorCliente } from "src/app/admihair/api/dto/indicador-cliente";
import { NgForm } from "@angular/forms";

@Component({
  selector: "app-central-cliente-editar",
  templateUrl: "./central-cliente-editar.component.html",
  styleUrls: ["./central-cliente-editar.component.scss"],
})
export class CentralClienteEditarComponent extends AdmihairBaseComponent implements OnInit {
  @ViewChild("f") form?: NgForm;
  progressoRequisicao: boolean = false;
  cliente?: Cliente;
  contatoCliente: ContatoCliente = { principal: true };
  listaContatos: ContatoCliente[] = [];
  loadingAdicionarContato: boolean = false;
  loadingExcluirContato: boolean = false;
  indicadoresClientes: string[] = [];

  aniversarioCliente?: string;
  dataValida: boolean = true;

  constructor(
    private clienteService: ClienteService,
    private contatoClienteService: ContatoClienteService,
    private confirmationService: ConfirmationService,
    private indicadorService: IndicadorClienteService,
    erroService: ErroService,
    storageService: UtilStorageService,
    router: Router,
    activatedRoute: ActivatedRoute
  ) {
    super(erroService, storageService, router, activatedRoute);
  }

  ngOnInit(): void {
    this.setExibirSpinnerPrincipal(true);
    this.carregarIdUrl();
    this.buscarCliente();
  }

  buscarCliente() {
    this.clienteService.buscarPorId(this.idParametroUrl).subscribe({
      next: (data: Cliente) => {
        this.cliente = data;
        if (this.cliente.aniversario) this.aniversarioCliente = this.converterAniversario(this.cliente.aniversario);
        this.listarContatosCliente();
        this.listarIndicadoresClientes();
      },
      error: (err: any) => {
        this.setExibirSpinnerPrincipal(false);
        this.exibirMensagemErro(err);
      },
    });
  }

  listarIndicadoresClientes() {
    this.indicadorService.listarIndicadoresClientesPorEmpresa(this.getEmpresa().id).subscribe({
      next: (data: IndicadorCliente[]) => {
        this.indicadoresClientes = data.map((item) => item.descricao);
      },
      error: (err: any) => {
        this.exibirMensagemErro(err);
      },
    });
  }

  atualizar() {
    this.progressoRequisicao = true;
    if (this.cliente) {
      this.cliente.aniversario = this.fomatarAniversario(this.aniversarioCliente);
      this.clienteService.atualizar(this.cliente, this.idParametroUrl).subscribe({
        next: (data: Cliente) => {
          this.cliente = data;
          this.progressoRequisicao = false;
          this.exibirMensagemSucesso();
        },
        error: (err: any) => {
          this.progressoRequisicao = false;
          this.exibirMensagemErro(err);
        },
      });
    }
  }

  adicionarContato() {
    this.loadingAdicionarContato = true;
    this.contatoCliente.cliente = this.cliente;
    this.contatoClienteService.salvar(this.contatoCliente).subscribe({
      next: () => {
        this.listarContatosCliente();
      },
      error: (err: any) => {
        this.loadingAdicionarContato = false;
        this.exibirMensagemErro(err);
      },
    });
  }

  listarContatosCliente() {
    this.contatoClienteService.listarPorClienteId(this.cliente?.id).subscribe({
      next: (data: ContatoCliente[]) => {
        this.listaContatos = data;
        this.loadingAdicionarContato = false;
        this.loadingExcluirContato = false;
        this.contatoCliente = { principal: true };
        this.setExibirSpinnerPrincipal(false);
      },
      error: (err: any) => {
        this.setExibirSpinnerPrincipal(false);
        this.loadingAdicionarContato = false;
        this.loadingExcluirContato = false;
        this.exibirMensagemErro(err);
      },
    });
  }

  validarContatoCliente(): boolean {
    return this.contatoCliente.numero !== undefined && this.contatoCliente.numero.length === 14;
  }

  excluirContato(contatoId: number) {
    this.confirmationService.confirm({
      message: "Tem certeza que seja excluir?",
      header: "Confirmação",
      acceptLabel: "Sim",
      rejectLabel: "Não",
      icon: "pi pi-info-circle",
      accept: () => {
        this.loadingExcluirContato = true;
        this.contatoClienteService.excluir(contatoId).subscribe({
          next: () => {
            this.listarContatosCliente();
          },
          error: (err: any) => {
            this.loadingExcluirContato = false;
            this.exibirMensagemErro(err);
          },
        });
      },
    });
  }

  editarContato(contato: ContatoCliente) {
    this.contatoCliente = contato;
    this.removerContato(contato);
  }

  removerContato(contato: ContatoCliente) {
    const posicao = this.listaContatos.indexOf(contato);
    this.listaContatos.splice(posicao, 1);
  }

  mostrarBotoes(): boolean {
    return Object.keys(this.contatoCliente).length > 1;
  }

  converterAniversario(aniversario: Date): string {
    const data = aniversario?.toString();
    const [ano, mes, dia] = data.split("-").map(String);
    return dia + "" + mes;
  }

  fomatarAniversario(aniversario?: string): Date | undefined {
    if (aniversario !== "" && aniversario !== undefined) {
      const [day, month] = aniversario?.split("/");
      const dataFormatada = new Date(new Date().getFullYear(), Number(month) - 1, Number(day));
      return new Date(dataFormatada);
    }
    return undefined;
  }

  validarAniversario() {
    const aniversario = this.form?.value.aniversario;
    if (!aniversario) {
      return;
    }
    const [dia, mes] = aniversario.split("/").map(Number);
    if (isNaN(dia) || isNaN(mes)) {
      return;
    }
    const diasPorMes = [0, 31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    this.dataValida = mes >= 1 && mes <= 12 && dia >= 1 && dia <= diasPorMes[mes];
  }
}
